// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._equipments_1uht9_1 {
  /* Colors */
  --pa-equipments-tabs-background-color-inner: var(
    --pa-equipments-tabs-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  --perxis-auto-tabs-content-background-color: var(--pa-equipments-tabs-background-color-inner);
  --perxis-auto-collapse-padding: var(--perxis-auto-gap-vertical-sky-inner) 0;
  --perxis-auto-collapse-panel-padding: var(--perxis-auto-gap-vertical-sky-inner) 0;
}
._equipments_1uht9_1 .perxis-auto-1_18_1-divider.ant-5_24_1-divider {
  margin: 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
